import React from "react";
import { HintView } from "lib/components/index";

const Hint = () => (
  <HintView.Hint>
    <p>{I18n.t("papp.products.EditProductView.StepPricelist.hint.p1")}</p>

    <h3>{I18n.t("papp.products.EditProductView.StepPricelist.hint.p2")}</h3>
    <p>{I18n.t("papp.products.EditProductView.StepPricelist.hint.p3")}</p>

    <h3>{I18n.t("papp.products.EditProductView.StepPricelist.hint.p4")}</h3>
    <p>{I18n.t("papp.products.EditProductView.StepPricelist.hint.p5")}</p>

    <h3>{I18n.t("papp.products.EditProductView.StepPricelist.hint.p6")}</h3>
    <p>{I18n.t("papp.products.EditProductView.StepPricelist.hint.p7")}</p>
  </HintView.Hint>
);

export default Hint;



// WEBPACK FOOTER //
// ./src/modules/products/EditProductView/StepPricelist/StepPricelistHint.jsx